import { RestfulApiService } from './restful-api.service';
import { Comment } from '../model/comment';
import { RestfulModel } from '../model/restful-model';

class CommentService extends RestfulApiService<Comment, RestfulModel> {
    public constructor(private prefix: string) {
        super();
    }

    protected getFormName(): string {
        return 'comment';
    }

    protected getPath(parent: RestfulModel | undefined): string {
        if (!parent) {
            throw new Error('Parent must be provided');
        }

        return `${this.prefix}/${parent.id}/comments`;
    }
}

export const crisCommentService = new CommentService('cris-workflows');
export const seamCommentService = new CommentService('seam-workflows');
export const statAlertCommentService = new CommentService('qa/stat-alerts');
